// Displayed hero image widths per breakpoint — mirrors the max-w-* classes in
// the platform HeaderSectionRight wrappers. Shared by the hero <img> srcset
// and the +Head.jsx preload hint so both resolve to the SAME variant URL
// (a mismatch would double-download the hero).
export const HERO_SIZES =
  "(min-width: 1536px) 700px, (min-width: 1280px) 600px, (min-width: 1024px) 450px, (min-width: 768px) 350px, 90vw"
